<template>
  <div :class="isEdu?'box box-edu':'box'">
    <el-row type="flex" justify="space-between" class="inner">
      <el-col :span="12" style="min-width:500px">
        <el-row type="flex" align="middle">
          <div class="logo">
            <img
              :src="isEdu?'images/manager-logo.png':'images/teacher-logo.png'"
              class="logo"
            />
          </div>
          <div :class="isEdu?'title title-edu':'title'">| 预约抢号管理系统</div>
        </el-row>
      </el-col>
      <div class="flex-row-reverse">
        <el-row type="flex" align="middle">
          <!-- <i class="el-icon-s-custom" style="color:#949dc4"></i> -->
          <div :class="isEdu?'name name-edu':'name'">{{userInfo.nickname}} , 您好 <span class="logout" @click="logout">退出</span></div>
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Head",
  data() {
    return {
      isEdu: false,
      userInfo: {}
    };
  },
  methods: {
    initView(){
      if(this.userInfo.nickname == undefined){
        this.userInfo = this.$global.userInfo
        switch (this.userInfo.utype) {
          case 2: //部门主管
          case 16: //机构
          case 20: //家长+机构
          case 24: //老师+机构
          case 32: //学校管理员
          case 64: //教育局管理员
            this.isEdu = true;
            break;
          case 8: //教师
          default:
            this.isEdu = false;
            break;
        }
      }
    },
    logout(){
				this.$request.getNDNF(this.$url.type.user,'/logout',response=>{
					window.location.href="/login.html"
				})
			}
  }
};
</script>

<style scoped>
.box {
  height: 74px;
  width: 100%;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-top: 6px solid #4a90e2;
  z-index: 100;
}
.box-edu {
  border-top: 6px solid #6775a3;
}

.inner {
  margin: 15px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
  color: #4a90e2;
}

.title-edu {
  color: #7985b5;
}
.name {
  color: #203f62;
  margin-left: 10px;
}

.name-edu {
  color: #203f62;
}

.flex-row-reverse {
  padding-top: 12px;
  font-size: 14px;
  float:right;
  margin-right:50px;
}

.logout{
  cursor: pointer;
  margin-left: 20px
}

.logout:hover{
  opacity:0.6
}
</style>
